
export const ACTION_TYPES = {
    ADD_ROUTE: 'ADD_ROUTE',
    CLEAN_ROUTES: 'CLEAN_ROUTES'
}

export const add_route = (data) => dispatch => {
    dispatch({
        type: ACTION_TYPES.ADD_ROUTE,
        payload: data
    })
}

export const clean_routes = (data) => dispatch => {
    dispatch({
        type: ACTION_TYPES.CLEAN_ROUTES,
        payload: data
    })
}